var {AmpersandState} = require('catalog/libs');

/**
 * selected filter + group expansion state model
 */
module.exports = AmpersandState.extend({

    props: {
        selectedFilters: 'object',
        groupsExpanded: 'object'
    }
});
